var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_84)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4931 22.2355L45.1567 22.492C45.9107 26.938 44.1706 29.674 42.6625 33.0654C37.8191 44.1233 41.9664 42.5274 27.1172 42.4989C24.42 42.4989 20.5917 42.9548 18.5616 42.0144L18.2715 24.4585C18.2715 19.3285 19.1416 19.756 21.7518 17.1341C23.4629 15.4241 25.6671 12.8306 27.6103 11.7191L25.4931 22.2355ZM13.7472 25.4845C13.7472 49.9943 10.6439 46.9163 34.9479 46.9163C43.6486 46.9163 41.6184 46.4603 47.7379 32.9514C49.42 29.2465 50.5221 26.9095 49.7971 22.0075C49.043 16.9916 42.6335 18.274 35.9919 18.274H31.4966C31.0616 12.0041 36.224 5.22114 29.7564 2.94116L15.1683 17.3335C13.1091 19.756 13.7472 21.9505 13.7472 25.4845ZM9.28081 43.3538C9.28081 40.6749 9.88986 21.8365 8.96178 20.839C8.20772 20.041 3.45134 20.1835 2.14624 20.3545C-0.986014 20.7535 0.232083 24.6865 0.232083 32.1249C0.232083 48.7973 -1.33404 46.9448 5.85853 46.9733C9.97686 47.0018 9.30981 47.2013 9.28081 43.3538Z",
    fill: "#8B0E01"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_84"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/ThumbsUp.1c52219afcd6fc319b28f5c6361bc3dd.svg";
export { ForwardRef as ReactComponent };